import React from 'react';
import { Grid, Box, Typography, Stack, Link as MuiLink } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft16Filled } from '@fluentui/react-icons';
import { useSidebarContext } from '../../context/SidebarContext';


const PageLayout = ({ title, actions, children, showBackButton = false }) => {
  const navigate = useNavigate();
  const { isSidebarOpen } = useSidebarContext();

  return (
    <Grid container sx={{ 
      width: `calc(100vw - ${isSidebarOpen ? 220 : 80}px - 4rem)`,
      overflowX: "hidden",
    }}>
      {/* Back Button */}
      <Stack>
      {showBackButton && (
        <Stack direction="row" alignItems="center" sx={{ mb: 0.5 }}>
          <MuiLink
            component="button"
            onClick={() => navigate(-1)}
            underline="hover"
            sx={{
              cursor: 'pointer',
              color: 'var(--navyBlue-light)',
              fontWeight: '600',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <ChevronLeft16Filled />
            Back
          </MuiLink>
        </Stack>
      )}

      {/* Header Section (Title + Optional Buttons) */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb="1.5rem"
      >
        <Typography variant="h2">{title}</Typography>
        {actions && (
          <Stack direction="row" spacing={2}>
            {actions}
          </Stack>
        )}
      </Stack>
      </Stack>

      {/* White Box Wrapper for Main Content*/}
      <Box
        sx={{
          backgroundColor: 'var(--white)',
          borderRadius: '12px',
          padding: '2rem',
          border: '1px solid var(--gray-200)',
          display: 'flex',
          flexDirection: 'column',
          gap: '2rem',
          overflowX: "auto",
          width: "100%",
        }}
      >
        {children}
      </Box>
    </Grid>
  );
};

export default PageLayout;
